import { render, staticRenderFns } from "./epmsa110.vue?vue&type=template&id=70b56663&scoped=true"
import script from "./epmsa110.vue?vue&type=script&lang=js"
export * from "./epmsa110.vue?vue&type=script&lang=js"
import style0 from "./epmsa110.vue?vue&type=style&index=0&id=70b56663&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b56663",
  null
  
)

export default component.exports